<template>
  <V2AtomsBaseCard
    ref="authorBlockWrapper"
    class="!max-w-wrapper-md mx-auto"
    :class="{
      'border border-semantic-surface-container': bordered,
    }"
  >
    <NuxtImg
      v-if="image"
      alt="author image"
      loading="lazy"
      class="wh-20 md:mb-6 mb-4"
      :src="image"
      :width="(dimensions && dimensions.width) || 192"
      :height="(dimensions && dimensions.height) || 192"
    />

    <template
      v-if="
        (title || $slots.title) &&
          (description || $slots.description)
      "
    >
      <div
        v-if="title || $slots.title"
        class="text-semantic-surface-on-surface font-semibold md:mb-6 text-lg/[120%] md:text-2xl/[120%] mb-4"
      >
        <slot name="title">
          {{ title }}
        </slot>
      </div>

      <div
        v-if="description || $slots.description"
        class="text-semantic-surface-on-surface font-normal text-sm/[150%] md:text-base/[150%]"
      >
        <slot
          name="description"
          :description="description"
        >
          {{ description }}
        </slot>
      </div>
    </template>

    <div v-if="listTitle && list && list.length > 0">
      <hr class="border-1 border-t-0 border-semantic-outline-variant md:my-6 my-4" />

      <div
        class="font-semibold text-semantic-surface-on-surface text-xl/[150%] md:text-2xl/[150%] md:mb-6 mb-4"
      >
        {{ listTitle }}
      </div>

      <V2AtomsList
        type="ordered"
        :items="list"
      />
    </div>
  </V2AtomsBaseCard>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesCardExpertCard'
})

defineProps({
  // Local Images are stored under /public/images/authors
  image: {
    type: String,
    default: ''
  },

  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  },

  listTitle: {
    type: String,
    default: ''
  },

  bordered: {
    type: Boolean,
    default: true
  },

  list: {
    type: Array,
    default: () => []
  },

  dimensions: {
    type: Object,
    default: () => {
      return {
        width: 192,
        height: 192
      }
    }
  }
})
</script>
